var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddCarinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M15.876 10h4.783l2.015 1.838a1 1 0 0 1 .326.739V19h-6a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2H1v-6.382H.986A.502.502 0 0 0 .5 12a.5.5 0 0 0-.494.577H0V22a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-3h12v3a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-9.423a2 2 0 0 0-.652-1.478L22.143 10H23a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-2.364l-1.74-3.828A2 2 0 0 0 17.076 2H13.5a.5.5 0 0 0 0 1h3.576a1 1 0 0 1 .91.586L20.447 9h-4.46a9.01 9.01 0 0 1-.111 1ZM16 19H8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Zm7 3v-2h-4v3h3a1 1 0 0 0 1-1ZM1 20h4v3H2a1 1 0 0 1-1-1v-2ZM23 8h-1.738l.41 1H23V8Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M22 13v1a2 2 0 0 1-2 2h-4a1 1 0 0 1-1-1v-2h7Zm-6 1h5a1 1 0 0 1-1 1h-4v-1Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 4h12v21H0z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.563 4.563a.563.563 0 0 0-1.125 0v4.875H.563a.563.563 0 0 0 0 1.124h4.875v4.876a.562.562 0 1 0 1.125 0v-4.876h4.875a.562.562 0 1 0 0-1.124H6.561V4.561Z"
})));
export default SvgAddCarinline;